import * as types from '../../constants/action_types'

export const initialState = {
  samplesBySupplierGroupMap: {},

  compareSamples: {
    isLoading: false,
    completed: false,
    samples: []
  },

  saveSample: {
    isLoading: false,
    completed: false
  },

  deleteSample: {
    isLoading: false,
    completed: false
  },

  sample: {
    name: '',
    rating: 0,
    notes: '',
    photos: []
  }
}

function supplierTrackerSamplesReducer(state = initialState, action) {
  switch (action.type) {
    case types.SET_SAMPLES:
      return {
        ...state,
        samplesBySupplierGroupMap: {
          ...state.samplesBySupplierGroupMap,
          ...action.payload
        }
      }
    case types.SET_COMPARE_SAMPLES:
      return {
        ...state,
        compareSamples: {
          ...state.compareSamples,
          samples: action.payload
        }
      }
    case types.PENDING_SAMPLES_ACTION:
      return {
        ...state,
        [action.payload]: {
          isLoading: true,
          completed: false
        }
      }
    case types.COMPLETED_SAMPLES_ACTION:
      return {
        ...state,
        [action.payload]: {
          ...state[action.payload],
          isLoading: false,
          completed: true
        }
      }
    case types.RESET_SAMPLES_ACTION:
      return {
        ...state,
        [action.payload]: {
          isLoading: false,
          completed: false
        }
      }
    case types.SET_SAMPLE:
      return {
        ...state,
        sample: {
          ...initialState.sample,
          ...action.payload
        }
      }
    default:
      return state
  }
}

export default supplierTrackerSamplesReducer
